import React from 'react';
import { USPCardStyles as S } from './USPCard.styles';
const USPCard = (props) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Heading, null, props.heading),
        React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } })));
};
export default USPCard;
